import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { format, isPast } from 'date-fns'

import en from 'date-fns/locale/en'
import fr from 'date-fns/locale/fr'
import es from 'date-fns/locale/es'
import de from 'date-fns/locale/de'

@Component
export default class Date extends Vue {
  locales = { en, fr, es, de }

  @Getter('locale', { namespace: 'user' }) locale

  dateIsBeforeNow(date) {
    return isPast(date)
  }

  // get formattedPickerDate(): string {
  //   return format(this.date, 'D MMM YY', {
  //     locale: this.locales[this.locale]
  //   })
  // }

  formatedDate(date, pattern): string {
    return format(date, pattern, {
      locale: this.locales[this.locale]
    })
  }
}

